import { LucideIcon } from "lucide-react";

interface ChallengeCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  iconColor: string;
}

const ChallengeCard = ({ icon: Icon, title, description, iconColor }: ChallengeCardProps) => {
  return (
    <div className="bg-card p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
      <div className={`${iconColor} text-4xl mb-6`}>
        <Icon className="w-10 h-10" />
      </div>
      <h3 className="text-card-foreground mb-4">{title}</h3>
      <p className="text-muted-foreground leading-relaxed">{description}</p>
    </div>
  );
};

export default ChallengeCard;
